import axiosInstance from '../../api/axiosInstance';

export const generarGuiaEnviaCom = async (
  cotizacion: any,
  formData: any,
  orderDetail: any
) => {
  const token = localStorage.getItem("accessToken");
  if (!token) {
    throw new Error("Error de autenticación");
  }

  console.log('📦 Datos de la cotización recibida:', cotizacion);
  console.log('🔍 Servicio de la cotización:', cotizacion.data?.service);
  console.log('🔍 Datos completos del servicio:', cotizacion.data);

  // Función auxiliar para obtener código de ciudad
  const getCiudadCodigo = (nombreCiudad: string) => {
    const Ciudades = require('../../assets/data/ciudades.json');
    const ciudad = Ciudades.find((c: any) => c.ciudad === nombreCiudad);
    return ciudad ? ciudad.codigo : '05001';
  };

  // Función auxiliar para obtener código de departamento
  const getDepartamentoCodigo = (nombreDepartamento: string) => {
    const Departamentos = require('../../assets/data/departamentos.json');
    const depto = Departamentos.find((d: any) => d.Nombre === nombreDepartamento);
    return depto ? depto.Codigo.toString() : '05';
  };

  // Mapear carrier a formato del endpoint
  const mapCarrierToEndpoint = (carrier: string) => {
    // Normalizar el nombre del carrier (quitar espacios y convertir a minúsculas)
    const normalizedCarrier = carrier.toLowerCase().replace(/\s+/g, '');
    
    switch (normalizedCarrier) {
      case 'interrapidisimo':
        return 'interRapidisimo';
      case 'noventa9minutos':
        return 'noventa9Minutos';
      case 'deprisa':
        return 'deprisa';
      case 'coordinadora':
        return 'coordinadora';
      default:
        throw new Error(`Transportadora ${carrier} no soportada para generación de guía`);
    }
  };

  // Usar el servicio exacto de la cotización seleccionada
  const getServiceFromQuote = (service: string, carrier: string) => {
    console.log('🔍 Usando servicio de la cotización:', service);
    // Para Deprisa, usar "estandar" si no hay servicio específico
    if (carrier.toLowerCase() === 'deprisa' && (!service || service === 'ground')) {
      return 'estandar';
    }
    // Para Coordinadora, usar "ecommerce" si no hay servicio específico
    if (carrier.toLowerCase() === 'coordinadora' && (!service || service === 'ground')) {
      return 'ecommerce';
    }
    return service || 'estandar'; // Enviar exactamente el mismo servicio que se seleccionó
  };

  const requestData = {
    orderId: orderDetail.id.toString(),
    origin: {
      name: formData.origenNombre,
      company: formData.origenEmpresa || '',
      email: formData.origenEmail,
      phone: formData.origenCelular,
      street: formData.origenDireccion,
      number: formData.origenDireccion_2 || '',
      district: "other",
      city: "05001",
      state: "ANT",
      country: "CO",
      postalCode: "05001",
      reference: formData.origenReferencia || "",
      identification: {
        type: "CC",
        number: formData.origenNit || "12345678"
      }
    },
    destination: {
      name: formData.destinoNombre,
      company: formData.destinoEmpresa || '',
      email: formData.destinoEmail,
      phone: formData.destinoCelular,
      street: formData.destinoDireccion,
      number: formData.destinoDireccion_2 || '',
      district: "other",
      city: getCiudadCodigo(formData.destinoCiudad),
      state: getDepartamentoCodigo(formData.destinoDepartamento),
      country: "CO",
      postalCode: getCiudadCodigo(formData.destinoCiudad),
      reference: formData.destinoReferencia || "",
      identification: {
        type: "CC",
        number: formData.destinoNit || "87654321"
      }
    },
    packages: [{
      content: formData.contenido,
      amount: 1,
      type: "box",
      dimensions: {
        length: Math.round(formData.largo),
        width: Math.round(formData.ancho),
        height: Math.round(formData.altura)
      },
      weight: Number(formData.peso < 1 ? 1 : formData.peso),
      insurance: 0,
      declaredValue: Number(formData.valorDeclarado || 0),
      weightUnit: "KG",
      lengthUnit: "CM",
      ...(formData.metodoPago === 'cod' && orderDetail?.total ? {
        additionalServices: [{
          service: "cash_on_delivery",
          data: {
            amount: typeof orderDetail.total === 'string' ? orderDetail.total : orderDetail.total.toString(),
            currency: "COP"
          }
        }]
      } : {})
    }],
    shipment: {
      carrier: mapCarrierToEndpoint(cotizacion.carrier),
      service: getServiceFromQuote(cotizacion.data?.service || 'ground', cotizacion.carrier),
      type: 1
    },
    settings: {
      printFormat: "PDF",
      printSize: "STOCK_4X6",
      comments: formData.accion_notaguia || ""
    }
  };

  console.log('🚀 Shipment generado:', requestData.shipment);
  console.log('🚀 Generando guía con Envia.com:', JSON.stringify(requestData, null, 2));

  const response = await axiosInstance.post("/envia-com/generate", requestData, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  return response.data;
};
